import React, { Component, Fragment } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { Button } from 'reactstrap';

import ModalConfirmation from './ModalConfirmation';
import Confirm from '../../components/Confirm';
import Table, { ExpandableRow, ExpandedRow } from '../../components/ExpandableTable';


import actions from './actions';
/**
 * 1. Alguém acessa a agenda pela 1ª vez no dia atual
 * 2. Calcula a disponibilidade total para o dia a partir do cadastro prévio (tem o horário dos funcionários cadastrados e as exceções [faltas, ausências])
 * 3. Calcula as atividades do dia a partir da periodidade
 * 2. Divide as tarefas a serem executadas no dia atual
 * 2. Se houver tarefas pendentes do dia anterior, incrementa
 * 
 * Cada tarefa possui prioridade única
 */

class ListaAtividades extends Component {
  constructor(props) {
    super(props);

    this.state = {
      isOpen: false,
      isOpenOutOfOrder: false,
      isOpenError: false,
      value: {}
    };
  }

  componentDidMount() {
    this.props.actions.onLoadMinhasTarefas();
  }

  toggle = key => () => {
    this.setState(state => ({
      [key]: !state[key]
    }));
  };

  confirm = ({ value, observacao }) => {
    if (value.confirmacao) {
      this.setState({
        value,
        isOpenOutOfOrder: false,
        isOpen: true
      });
    } else {
      this.setState({
        isOpenOutOfOrder: false,
      });

      this.confirmModal(value)({
        observacao
      });
    }
  };

  onStartConfirmation = value => e => {
    e.preventDefault();
    e.stopPropagation();

    const { value: { result } } = this.props;

    if (0 < result.findIndex(v => v === value)) {
      this.setState({
        value,
        isOpenOutOfOrder: true
      });
    } else {
      this.confirm({ value, observacao: "Tarefa concluída na ordem." });
    }
  };

  confirmModal = value => data => {
    this.props.actions.onConfirmTask({
      value,
      ...data
    }).then(() => {
      this.setState({
        isOpen: false
      });
    }, ({ message }) => {
      switch (message) {
        case 'VALIDATION_OMIT':
          this.setState({
            isOpenError: true,
            message: 'Verifique se clicou na tarefa correta ou se apontou para o QR CODE correto.'
          });
          break;
        default:
          this.setState({
            isOpenError: true,
            message
          });
      }
    });
  };

  backgroundColor = tarefa => {
    if (tarefa.adiantado) return "alert-success";
    if (tarefa.atraso > 1) return "alert-danger";
    return "";
  }

  render () {
    let {
      value: { fetching, result/*, errors, lastModified*/ }
    } = this.props;

    let { value, isOpen, isOpenOutOfOrder, isOpenError, message } = this.state;

    return (<Fragment>
      <ModalConfirmation isOpen={isOpen} toggle={this.toggle('isOpen')} onConfirm={this.confirmModal(value)} />
      <Confirm isOpen={isOpenOutOfOrder} toggle={this.toggle('isOpenOutOfOrder')} onConfirm={() => this.confirm({value, observacao: "Tarefa concluída fora de ordem."})}>Conclusão de tarefa fora da ordem.</Confirm>
      <Confirm isOpen={isOpenError} toggle={this.toggle('isOpenError')} onConfirm={this.toggle('isOpenError')}>{message}</Confirm>
      <Table>
      {result.map((v, i) => (
        <ExpandableRow
        className={this.backgroundColor(v)}
        isOpen={!i}
        key={i}>
          <td>
            <div>{v.nome}</div>
          </td>
          <td className="text-right">
            {1 === fetching && value === v && (
              <Button color="dark" disabled title="Carregando...">
                <span className="fa fa-calendar" />{' '}
                <span className="d-none d-sm-inline-block">
                  Carregando...
                </span>
              </Button>
            )}
            <Button
              color="success"
              onClick={this.onStartConfirmation(v)}
              className="tarefas-button-concluir"
              title="Concluir!">
              <span className="fa fa-check" />{' '}
              <span className="d-none d-sm-inline-block">
                Concluir!
              </span>
            </Button>
          </td>
          <ExpandedRow style={{backgroundColor:"#EEE"}}>
          <pre>{v.descricao}</pre>
          </ExpandedRow>
        </ExpandableRow>
      ))}
    </Table></Fragment>);
  }
}

let mapStateToProps = ({ agenda }) => ({
  value: agenda.atividades
});

let mapDispatchToProps = dispatch => ({
  actions: bindActionCreators(actions, dispatch)
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ListaAtividades);


// WEBPACK FOOTER //
// ./src/modules/agenda/ListaAtividades.js